export function formatCurrencyToNumber(value: string): number | null {
  if (typeof value === 'number') return value;
  if (!value) return null;

  const valueFormated = value.slice(3).replaceAll('.', '').replaceAll(',', '.');
  return value.includes('-') ? -Number(valueFormated) : Number(valueFormated);
}
